// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1OVbt","label":"Section_label__2CAY-","contentWrap":"Section_contentWrap__eJEp5","footer":"Section_footer__1bAt1","footerInner":"Section_footerInner__KJHFe"};